@use '../../../../../design-tokens/typography/typography' as *;

@layer design-system {
  .styledForeign {
    text-align: center;
    line-height: 16px;
    vertical-align: middle;
  }

  .circleIcon {
    r: 2px;
  }

  .circleRingIcon {
    fill: none;
    r: 4px;
    stroke-width: 1;
  }

  .labelWrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .date {
    @include typography-v2-body-xs;
    color: var(--text-soft);
  }

  .value {
    @include typography-v2-body-sm;
  }
}
